export { getCurrentUrl };
import { normalizeClientSideUrl } from './normalizeClientSideUrl.js';
function getCurrentUrl(options) {
    return normalizeClientSideUrl(window.location.href, options);
}
